export default class Customer {
  name: string;
  surname: string;
  gsm: string;
  email: string;
}
